import React from 'react'
import pdf1 from "../pdfs/pdf1.pdf"
import pdf2 from "../pdfs/pdf2.pdf"
import pdf3 from "../pdfs/pdf3.pdf"
import pdf4 from "../pdfs/pdf4.pdf"

export default function Card({ title, text, pdf, isPdf }) {
    let pdfLink = '';

    switch (pdf) {
        case 'pdf1':
            pdfLink = pdf1;
            break;
        case 'pdf2':
            pdfLink = pdf2;
            break;
        case 'pdf3':
            pdfLink = pdf3;
            break;
        case 'pdf4':
            pdfLink = pdf4;
            break;
        default:
            pdfLink = '';
            break;
    }

    const handleDownload = () => {
        if (pdfLink) {
            // Create an anchor element
            const anchor = document.createElement('a');
            anchor.href = pdfLink;
            anchor.download = `${pdf}.pdf`; // Specify the filename
            anchor.click();
        }
    };

    function sendEmail() {
        window.location.href = "mailto:aleksandr.asad7@gmail.com";
      }

    return (
        <div className='card'>
            <h2>{title}</h2>
            <p>{text}</p>
            <div className="buttons">
                {
                    isPdf ? (
                        <>
                            <a href={pdfLink} target="_blank" rel="noreferrer"><button className='icon-btn'><i class="fa-solid fa-bars"></i></button></a>
                            <button onClick={handleDownload} className='icon-btn'><i className="fa-solid fa-download"></i></button>
                        </>
                    ) : (
                        <a href="mailto:myemail@email.ru"><button className='icon-btn'><i className="fa-regular fa-envelope"></i></button></a>
                    )
                }
            </div>
        </div>
    )
}
